import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFormValues, change } from 'redux-form';
import AddRemoveProgramsV3 from './AddRemoveProgramsV3';
import {
  BTN_FACTORY_V3_FORM,
  BTN_FACTORY_MAX_PROGRAMS,
} from '../../clientConstants';
import { Field } from 'redux-form';
import getLocaleMessages from '../../utils/localesMessages';
import { renderSwitchComponent } from '../switchPanels/SwitchPanel';
import { LightBulbIcon } from '@paypalcorp/pp-react-icons';

const {
  chooseSpecificPrograms,
  tooltip = {},
  programs = {},
} = getLocaleMessages('buttonsV3/programs');

const ProgramsV3 = ({ listPrograms, programNames, dispatch }) => {
  const addProgram = () => {
    if (programNames.length < BTN_FACTORY_MAX_PROGRAMS) {
      const newProgramNames = [...programNames, ''];
      dispatch(change(BTN_FACTORY_V3_FORM, 'programNames', newProgramNames));
    }
  };

  const togglePrograms = () => {
    // This method is now run via the onChange prop, which runs before the value is actually
    // changed in redux-form, thus needing to show the program when the value is still 'no'
    if (listPrograms === 'no') {
      if (programNames && programNames.length === 0) {
        addProgram();
      }
    }
  };

  const renderSubTitle = () => {
    return listPrograms === 'no' ? (
      <div className="programs-tip">
        <div className="icon">
          <LightBulbIcon size="sm" />
        </div>
        {programs.tip}
      </div>
    ) : (
      tooltip.program
    );
  };

  return (
    <div className="programs-container">
      <Field
        id="listPrograms"
        name="listPrograms"
        label="listPrograms"
        subTitle={renderSubTitle()}
        title={chooseSpecificPrograms}
        component={renderSwitchComponent}
        isChecked={listPrograms === 'yes'}
        onChange={togglePrograms}
      />

      {listPrograms === 'yes' && (
        <div className="button-style-elements">
          <AddRemoveProgramsV3 addProgram={addProgram} />
        </div>
      )}
    </div>
  );
};

ProgramsV3.propTypes = {
  listPrograms: PropTypes.string,
  programNames: PropTypes.array,
  dispatch: PropTypes.func,
};

const mapStateToProps = (state) => {
  const formValues = getFormValues(BTN_FACTORY_V3_FORM)(state) || {};
  return {
    listPrograms: formValues.listPrograms,
    programNames: formValues.programNames,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgramsV3);
